<template>
    <div
        :class="[
            'guide-text-container',
            {
                displayCopy: displayCopy
            }
        ]"
    >
        <div v-html="parseText"></div>
        <a v-if="displayCopy" class="copy" @click="$emit('copy', parseText)">{{ _lang('copy') }}</a>
    </div>
</template>

<script >
// 文本容器
import { computed } from 'vue-demi';
import { _lang } from '../common/lang';
import { appDataList, code, inviteLink } from '../common/payload';
import { getShareText } from '../common/share';
const __sfc_main = {};
__sfc_main.props = {
  text: {
    type: String,
    default: ''
  },
  channel: {
    type: String,
    default: ''
  },
  displayCopy: {
    type: Boolean,
    default: true
  },
  inviteLink: {
    type: String,
    default: ''
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  const parseText = computed(() => getShareText({
    desc: props.text,
    inviteLink: inviteLink.value || props.inviteLink,
    code: code.value,
    channel: props.channel,
    appDataList: appDataList.value
  }));
  return {
    _lang,
    parseText
  };
};
export default __sfc_main;
</script>

<style lang="less" scoped>
.guide-text-container {
    position: relative;
    margin: 0 0.32rem;
    padding: 0.32rem 0.4rem 0.64rem 0.4rem;
    flex-shrink: 0;
    border-radius: 0.16rem;
    background: #f5f5f5;
    & > div {
        white-space: pre-wrap;
        word-break: break-all; /* 强制换行（另一种方式，也可以使用） */
        color: #606266;
        font-feature-settings: 'liga' off, 'clig' off;
        font-size: 0.28rem;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    & > .copy {
        position: absolute;
        right: 0.31rem;
        bottom: 0.31rem;
        display: flex;
        padding: 0.1rem 0.36rem;
        justify-content: center;
        align-items: center;
        border-radius: 0.32rem;
        border: 0.02rem solid #aaa;
        color: #262626;
        text-align: center;
        font-feature-settings: 'liga' off, 'clig' off;
        font-size: 0.28528rem;
        font-style: normal;
        font-weight: 400;
        line-height: 0.31118rem;
    }
    &.displayCopy {
        padding-bottom: 1.4rem;
    }
}
</style>
